import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './lib/supabase.ts'
import App from './App.tsx'
import { safeSessionGet, safeSessionSet } from './lib/browserStorage'

const CHUNK_RELOAD_KEY = 'closedrecord:chunk-reload-at'
const CHUNK_RELOAD_COOLDOWN_MS = 15_000

if (typeof window !== 'undefined') {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()

    // When Cloudflare serves a stale HTML/JS pair during a rollout, Vite's
    // dynamic imports can point at chunks that no longer exist. Reload once
    // with a cache-busting query so the browser re-requests the current HTML.
    // Rate-limit the recovery so we don't bounce forever if the edge is still stale.
    const lastAttempt = Number(safeSessionGet(CHUNK_RELOAD_KEY) ?? '0')
    if (Number.isFinite(lastAttempt) && Date.now() - lastAttempt < CHUNK_RELOAD_COOLDOWN_MS) return

    safeSessionSet(CHUNK_RELOAD_KEY, String(Date.now()))
    const url = new URL(window.location.href)
    url.searchParams.set('__cr_reload', String(Date.now()))
    window.location.replace(url.toString())
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
